// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13.0001 2L13.0001 22H11.0001L11.0001 2L13.0001 2ZM9.00005 4.64087V18.5H1.30054L9.00005 4.64087ZM15.0001 4.64087L22.6996 18.5H15.0001V4.64087Z"}}]};

const MirrorFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'mirror-filled',
    ref,
    icon: element,
  },
));

MirrorFilledIcon.displayName = 'MirrorFilledIcon';

export default MirrorFilledIcon;
